import { trackBuyerChecklistEvent } from "../../../constants/buyerChecklistConstants";

export function ChecklistSaveButton({ listingId, onSaved, className = "", label = "Guardar checklist" }) {
  const handleSave = () => {
    trackBuyerChecklistEvent("buyer_checklist_progress_updated", { listingId, action: "save_acknowledged" });
    onSaved?.();
  };

  return (
    <button type="button" className={`buyer-checklist-btn buyer-checklist-btn--soft ${className}`.trim()} onClick={handleSave}>
      {label}
    </button>
  );
}

export function ChecklistPrintButton({ className = "", label = "Imprimir" }) {
  return (
    <button
      type="button"
      className={`buyer-checklist-btn buyer-checklist-btn--soft ${className}`.trim()}
      onClick={() => {
        trackBuyerChecklistEvent("buyer_checklist_print_clicked");
        window.print();
      }}
    >
      {label}
    </button>
  );
}

export function ChecklistShareButton({ url, className = "", label = "Compartir" }) {
  const handleShare = async () => {
    trackBuyerChecklistEvent("buyer_checklist_share_clicked");
    const shareUrl = url || window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({ title: "Checklist AutoMapa", url: shareUrl });
        return;
      } catch {
        /* user cancelled */
      }
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch {
      /* ignore */
    }
  };

  return (
    <button type="button" className={`buyer-checklist-btn buyer-checklist-btn--soft ${className}`.trim()} onClick={handleShare}>
      {label}
    </button>
  );
}
